import moment from 'moment';
export const FinanceUploadRequestsViewControls = {
    viewControl: {
      dateFilterOptions: [
        { key: 'created_at', val: 'Created At' },
      ],
    },
};

  export const uploadRequestsColumns = [
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Excel Action Type',
      dataIndex: 'action_type',
      key: 'action_type',
    },
    {
      title: 'Employee Code',
      dataIndex: 'employee_code',
      key: 'employee_code',
    },
    {
      title: 'Total Entries No',
      dataIndex: 'total_entries',
      key: 'total_entries',
    },
    {
      title: 'Success Entries',
      dataIndex: 'success_entries',
      key: 'success_entries',
    },
    {
      title: 'Ongoing Entries',
      dataIndex: 'ongoing_entries',
      key: 'ongoing_entries',
    },
    {
      title: 'Failed Entries',
      dataIndex: 'failed_entries',
      key: 'failed_entries',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
  ];

  export const formatDate = (dateString) => {
    if (!dateString || dateString.trim() === '') return '-';
    const momentDate = moment(dateString);
    return momentDate.isValid()
      ? momentDate.format('YYYY-MM-DD HH:mm:ss')
      : '-';
  };
